import { render, staticRenderFns } from "./resourceDownload.vue?vue&type=template&id=9ddfb110&scoped=true"
import script from "./resourceDownload.vue?vue&type=script&lang=js"
export * from "./resourceDownload.vue?vue&type=script&lang=js"
import style0 from "./resourceDownload.vue?vue&type=style&index=0&id=9ddfb110&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ddfb110",
  null
  
)

export default component.exports